import Swiper from 'swiper/bundle';

$(document).ready(function(){

    var swiper = new Swiper('.slider.discover-stadami', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        speed: 444,
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        loop: false,
        keyboard: {
            enabled: true
        },
    });

    function updateActiveSlide(index) {
        $(".slide-nav .slide-nav-item").removeClass("active completed");
        $(".slide-nav .s-" + index).addClass("active");
        for (let i = 1; i < index; i++) {
            $(".slide-nav .s-" + i).addClass("completed");
        }

        if (window.innerWidth < 768) {
            centerActiveNavItem(".slide-nav .s-" + index);
        }
    }

    swiper.on('slideChangeTransitionStart', function() {
        let activeIndex = $(".swiper-slide-active").index() + 1;
        updateActiveSlide(activeIndex);
    });

    $(".slide-nav .slide-nav-item").click(function(){
        let index = $(this).index() + 1;
        swiper.slideTo(index - 1);
        updateActiveSlide(index);
    });

    function centerActiveNavItem(activeSelector) {
        const $activeItem = $(activeSelector);
        if ($activeItem.length) {
            const $scrollContainer = $('.section-discover-stadami .wrap-scroll');
            const activeOffsetLeft = $activeItem[0].offsetLeft;
            const activeWidth = $activeItem.outerWidth();
            const containerWidth = $scrollContainer.width();
            const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);
            $scrollContainer.scrollLeft(scrollPosition);
        }
    }

    updateActiveSlide(1);
});
